export default {
  style:
    "https://api.maptiler.com/maps/positron/style.json?key=SELoX3dFYxqCMV1fdoy3",
  showMarkers: false,
  markerColor: "#3FB1CE",
  inset: false,
  theme: "light",
  use3dTerrain: false,
  useCustomLayers: true,
  title:
    "Using drones and sensors to monitor emissions in extreme environments without internet connection",
  byline: "MISO Teams",
  footer: "Study by: Torbjørn Heltne, Huy Duong Gia",

  chapters: [
    {
      id: "senseair-sweden",
      alignment: "right",
      hidden: false,
      title: "Innovative sensor technology",
      image: "../images/K96_sensor.png",
      caption: "Senseair, Delsbo, Sweden",
      description:
        "Senseair has developed the K96 sensor using photonic technology based on non-dispersive infrared (NDIR) sensing. This compact sensor can detect CH₄ and CO₂ simultaneously using a single infrared light source—a breakthrough that makes large-scale deployment more practical and affordable. The K96 is designed for use in hard-to-reach areas where traditional monitoring equipment would be too expensive or difficult to maintain.",
      location: {
        center: [16.6283, 61.7923],
        zoom: 8,
        pitch: 15,
        bearing: 30,
      },
      mapAnimation: "flyTo",
      rotateAnimation: false,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "observatory-1",
      alignment: "left",
      hidden: false,
      title: "MISO Observatory 1 - Plug-and-play Gas Ambient Monitor",
      image: "../images/gas-ambient.png",
      caption: "NILU Kjeller, Norway",
      description:
        "Plug-and-play gas ambient monitor for CH₄ and CO₂ sensing. Gas continuous ambient monitor integrates data acquisition platform with NDIR sensors and Machine Learning based calibration model to autonomously and continuously measure ambient gas (CH₄ and CO₂) concentration in the air.",
      location: {
        center: [11.052707, 59.975438],
        zoom: 11,
        pitch: 40,
        bearing: 40,
      },
      mapAnimation: "flyTo",
      rotateAnimation: true,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "observatory-2",
      alignment: "right",
      hidden: false,
      title: "MISO Observatory 2 - Gas Flux Chamber",
      image: "../images/gas-flux.png",
      caption: "Bremerhaven, Germany",
      description:
        "Gas flux chamber for CH₄ and CO₂ source sensing. 'Right cost' and automated gas flux chambers for direct-source measurements.",
      location: {
        center: [8.5783, 53.5395],
        zoom: 10,
        pitch: 30,
        bearing: 0,
      },
      mapAnimation: "flyTo",
      rotateAnimation: false,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "observatory-3",
      alignment: "left",
      hidden: false,
      title: "MISO Observatory 3 - UAV-based Monitor",
      image: "../images/sandy-drone.png",
      caption: "Mérignac, France",
      description:
        "UAV-based monitor to allow vertical and horizontal measurements to make spatial upscaling of gas concentration and fluxes more robust and accurate.",
      location: {
        center: [-0.6458, 44.8378],
        zoom: 12,
        pitch: 55,
        bearing: -20,
      },
      mapAnimation: "flyTo",
      rotateAnimation: true,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "lab-calibration",
      alignment: "left",
      hidden: false,
      title: "Lab Calibration for the Observatories",
      image: "../images/nilu.png",
      caption: "NILU Kjeller, Norway",
      description:
        "We conducted multiple lab tests of our methane (CH₄) sensors and confirmed that routine meteorological factors—temperature, humidity, and pressure—are the primary source of baseline drift in raw readings. To address this, we developed an AI-based calibration model that learns how these environmental conditions shift the sensor’s baseline.",
      location: {
        center: [11.052707, 59.975438],
        zoom: 4,
        pitch: 0,
        bearing: 0,
      },
      mapAnimation: "flyTo",
      rotateAnimation: true,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "lab-equipment",
      alignment: "right",
      hidden: false,
      title: "Lab Equipment at NILU",
      image: "../images/utstyr.png",
      caption: "NILU Kjeller, Norway",
      description:
        "The advanced equipment at NILU plays a crucial role in ensuring the accuracy and reliability of our methane sensor calibration.",
      location: {
        center: [11.052707, 59.975438],
        zoom: 11,
        pitch: 40,
        bearing: 40,
      },
      mapAnimation: "flyTo",
      rotateAnimation: true,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "field-experiment",
      alignment: "left",
      hidden: false,
      title: "Field Experiment Validation",
      image: "../images/france.png",
      caption: "Azur Drones, Bordeaux, France",
      description:
        "From May 12 to 14, partners of the MISO project came together in Bordeaux for our second collaborative field experiment. Researchers and engineers worked side by side to test and refine sensor technologies developed within the project, focusing on reliability and accuracy across real-world conditions.",
      location: {
        center: [-0.57918, 44.837789],
        zoom: 5,
        pitch: 0,
        bearing: 0,
      },
      mapAnimation: "flyTo",
      rotateAnimation: false,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "drone-testing",
      alignment: "right",
      hidden: false,
      title: "Drone Testing in Bordeaux",
      image: "../images/drone.png",
      caption: "Azur Drones, Bordeaux, France",
      description:
        "The drones were equipped with LoRa radio modules, allowing us to test long-range, low-power communication for sensor data transmission in remote areas.",
      location: {
        center: [-0.57918, 44.837789],
        zoom: 12,
        pitch: 55,
        bearing: -20,
      },
      mapAnimation: "flyTo",
      rotateAnimation: false,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "drone-flight",
      alignment: "left",
      hidden: false,
      title: "Drone in Action",
      image: "../images/flying.png",
      caption: "Azur Drones, Bordeaux, France",
      description:
        "The drones performed extensive flights to validate their ability to detect and transmit data under varying environmental conditions.",
      location: {
        center: [-0.57918, 44.837789],
        zoom: 12,
        pitch: 55,
        bearing: -20,
      },
      mapAnimation: "flyTo",
      rotateAnimation: true,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "wetlands-validation",
      alignment: "right",
      hidden: false,
      title: "Wetland Validation UAV-based measurements",
      image: "../images/high.png",
      caption: "Hyytiälä Forest Station, Finland",
      description:
        "We completed our intensive field campaign at Hyytiälä Forest Station, Finland, validating our technologies under real wetland conditions.",
      location: {
        center: [24.2948, 61.8476],
        zoom: 6,
        pitch: 20,
        bearing: -10,
      },
      mapAnimation: "flyTo",
      rotateAnimation: false,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "sensor-testing",
      alignment: "left",
      hidden: false,
      title: "Wetland validation - Gas Ambient Measurements",
      image: "../images/station.png",
      caption: "Hyytiälä Forest Station, Finland",
      description:
        "Greenhouse gases were monitored using our sensors and compared against high-cost reference instruments, providing insightful comparisons.",
      location: {
        center: [24.2948, 61.8476],
        zoom: 12,
        pitch: -50,
        bearing: 50,
      },
      mapAnimation: "flyTo",
      rotateAnimation: false,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "instrument-validation",
      alignment: "right",
      hidden: false,
      title: "Wetland Validation - Gas Flux Measurements",
      image: "../images/instrument.png",
      caption: "Hyytiälä Forest Station, Finland",
      description:
        "The MISO sensor chamber was tested against the Auto chamber, providing valuable data on greenhouse gas flux measurements.",
      location: {
        center: [24.2948, 61.8476],
        zoom: 12,
        pitch: -50,
        bearing: 50,
      },
      mapAnimation: "flyTo",
      rotateAnimation: false,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
    {
      id: "pilot-arctic",
      alignment: "left",
      hidden: false,
      title: "Pilot 2 - The Arctic",
      description:
        "Key partner of MISO, Azur Drones, has finished installing an autonomous drone system in Svalbard. The system is ready for a full Arctic pilot to monitor CH₄ and CO₂ in hard-to-reach areas, focusing on emissions from thawing permafrost and melting ice.",
      location: {
        center: [15.633, 78.222],
        zoom: 6,
        pitch: 80,
        bearing: 0,
      },
      mapAnimation: "flyTo",
      rotateAnimation: true,
      mapInteractive: true,
      callback: "",
      onChapterEnter: [],
      onChapterExit: [],
    },
  ],
};
